// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBackdrop_root__Yyms0","active":"HeaderBackdrop_active___LoYK","inactive":"HeaderBackdrop_inactive__XUZLl"};